import React, { useState, useEffect } from 'react';
import './SimpleApp.css';

const API_URL = 'https://kep00s65oa.execute-api.us-east-1.amazonaws.com/prod';

function SimpleApp() {
  const [squares, setSquares] = useState({});
  const [userEmail, setUserEmail] = useState('');
  const [loading, setLoading] = useState(null);

  useEffect(() => {
    loadGameState();
  }, []);

  const loadGameState = async () => {
    try {
      const response = await fetch(`${API_URL}/game`);
      const data = await response.json();
      setSquares(data.squares || {});
    } catch (error) {
      console.error('Failed to load game state:', error);
    }
  };

  const claimSquare = async (squareId) => {
    if (!userEmail.trim()) {
      alert('Please enter your email first');
      return;
    }

    setLoading(squareId);
    try {
      const response = await fetch(`${API_URL}/game`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ squareId, userEmail: userEmail.trim() })
      });

      const data = await response.json();
      if (data.success) {
        await loadGameState(); // Refresh state
      } else {
        alert(data.error || 'Failed to claim square');
      }
    } catch (error) {
      alert('Failed to claim square');
    } finally {
      setLoading(null);
    }
  };

  const renderGrid = () => {
    const grid = [];
    for (let i = 0; i < 100; i++) {
      const square = squares[i] || {};
      const isLoading = loading === i;
      const isClaimed = square.claimed;
      
      grid.push(
        <div
          key={i}
          className={`square ${isClaimed ? 'claimed' : 'available'} ${isLoading ? 'loading' : ''}`}
          onClick={() => !isClaimed && !isLoading && claimSquare(i)}
        >
          {isClaimed ? square.claimedBy?.split('@')[0] : i}
        </div>
      );
    }
    return grid;
  };

  const claimedCount = Object.values(squares).filter(s => s.claimed).length;

  return (
    <div className="app">
      <header>
        <h1>🏈 Superbowl Squares</h1>
      </header>
      
      <div className="controls">
        <input
          type="email"
          placeholder="Enter your email"
          value={userEmail}
          onChange={(e) => setUserEmail(e.target.value)}
        />
        <button onClick={loadGameState}>Refresh</button>
      </div>

      <div className="info">
        <p>Squares claimed: {claimedCount}/100</p>
      </div>

      <div className="grid">
        {renderGrid()}
      </div>
    </div>
  );
}

export default SimpleApp;
